<template>
    <b-container v-if="!ready">
        <b-row class="vh-100 text-center" align-v="center">
            <b-col>
                <b-spinner variant="light" />
            </b-col>
        </b-row>
    </b-container>
    <TemplateEditor v-model="nodes" @save="save" :saving="saving" v-else>
        <template #nav>
            <b-nav-item-dropdown class="" text="Files">
                <b-dropdown-item @click="save(false)">Save All</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item-dropdown :text="`SDK ${SDKVersion}`">
                <b-dropdown-item disabled>4 <small>(deprecated)</small></b-dropdown-item>
                <b-dropdown-item @click="SDKVersion = 5">5</b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
    </TemplateEditor>
</template>

<script>
import TemplateEditor from '../editor/TemplateEditor.vue'
import _ from 'lodash'
import { Builder } from 'protokol-sdk'
import Vue from 'vue'
import { TreeNode } from 'vue-tree-list'

export default {
    name: 'EditorV5',
    components: {
        TemplateEditor
    },
    data: function() {
        return {
            component: null,
            nodes: null,
            saving: false,
            ready: false,
            SDKVersion: 5,
            SDKEngine: 'vue2',
        }
    },
    computed: {
        settings() {
            return this.component.settings
        },
    },
    watch: {
        data: function(o, n) {
            console.log(n)
        }
    },
    methods: {
        save: _.debounce(async function() {
            this.saving = true;
            try {
                const templates = JSON.parse([this.nodes[0].children[0].toString()])
                const results = await this.getBuilder().buildFromNodes(templates.children)

                this.$http.post(`/v3/system/component/templates/${this.component.general.uuid}/${this.settings.version}`, {
                    nodes: templates.children,
                    templates_dist: {
                        sdk_version: this.SDKVersion,
                        sdk_engine: this.SDKEngine,
                        dist: results
                    }
                }).then(() => {
                    this.$bvToast.toast('Saved successfully', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 5000
                    })
                }).catch(err => {
                    this.$debugLog(err)

                    if (err.response) {
                        this.$bvToast.toast(err.response.data.message, {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        })

                        return
                    }

                    this.$bvToast.toast(err.message, {
                        title: this.$t('error'),
                        variant: 'danger',
                        autoHideDelay: 5000
                    })
                    
                })

            } catch (err) {
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: this.$t('error'),
                    variant: 'danger',
                    autoHideDelay: 5000
                })
            } finally {
                this.saving = false
            }

            
        }, 500),

        getBuilder() {
            return new Builder(this.SDKVersion, this.SDKEngine)
        },

        async onDel(node) {
            let resp = await this.$bvModal.msgBoxConfirm("Are you sure you want to delete " + node.name + "?", {
                headerBgVariant: "dark",
                bodyBgVariant: "dark",
                footerBgVariant: "dark"
            });
            if (!resp) return;
            
            node.remove()
        },

        onChangeName(node) {
            if (node.node) {
                // decide extension of name
                node.node.path = this.generateNodePath(node.node, node.newName)
                // set ext of the file
                node.node.ext = this.resolveFileExt(node.newName)
                node.node.editorOptions.mode = this.resolveEditorMode(node.node.ext)
                // find active editor and change mode of editor depending on ext
                let activeEditor = this.findNodeByID(node.id, this.activeEditors)
                if (activeEditor) {
                    activeEditor = node.node
                }
            }
        },    

        resolveFileExt(name) {
            let parts = name.split(".")
            return parts[parts.length - 1]
        },

        resolveEditorMode(ext) {
            switch(ext) {
                case 'vue': return "text/x-vue";
                case 'js': return "application/javascript";
                default: return "text/plain";
            }
        },

        onClick(params) {
            if (!params.isLeaf) return;

            params.path = this.generateNodePath(params)

            let found = this.activeEditors.find(e => {
                return e.id == params.id
            })

            if (!found) 
                this.activeEditors.push(params)
        },

        addNode(node) {
            if (!node.isLeaf) return;

            node.path = this.generateNodePath(node, node.name)
            node.editorOptions = {
                mode: this.resolveEditorMode(this.resolveFileExt(node.name))
            }
        },

        generateNodePath(n,p) {
            let path = p
            
            if (n && n.parent) {
                path = n.parent.name + "/" + path
            
                return this.generateNodePath(n.parent, path)
            }
            
            return path.replaceAll("root/" + this.component.general.name + "/Templates/", "")
        },

        editorOptions(override) {
            return {
                tabSize: 2,
                line: true,
                autoRefresh: true,
                lineNumbers: true,
                foldGutter: true,
                firstLineNumber: 1,
                styleSelectedText: true,
                matchBrackets: true,
                showCursorWhenSelecting: true,
                theme: 'material-palenight',
                ...override
            }
        },

        editorInput: _.debounce(function(activeEditor, val) {
            let node = this.findNodeByID(activeEditor.id)
            
            node.content = val
        }, 500),

        currentEditorValue(activeEditor) {
            return activeEditor.content || ""
        },

        findNodeByID(id, nodes) {
            if (!nodes) {
                nodes = this.data.children
            }

            let node = null
            for (let i = 0; i <= nodes.length; i++) {
                if (!nodes[i]) continue;

                if (nodes[i].id == id) {
                    node = nodes[i]
                    break
                }

                node = this.findNodeByID(id, nodes[i].children || [])
            }

            return node
        },

        closeActiveEditor(editor) {
            if (this.activeEditors.length < 2) return;

            this.activeEditors = this.activeEditors.filter(e => {
                return e.id != editor.id
            })
        },

        setMenu(top, left) {     
            let largestHeight = window.innerHeight - this.$refs.right.offsetHeight - 25;
            let largestWidth = window.innerWidth - this.$refs.right.offsetWidth - 25;

            if (top > largestHeight) top = largestHeight;

            if (left > largestWidth) left = largestWidth;

            this.top = top + 'px';
            this.left = left + 'px';
        },

        closeMenu() {
            this.viewMenu = false;
        },

        openMenu(e, node) {
            e.preventDefault();

            this.currentMenuNode = node;

            if (this.nodeActions().length < 1) {
                return
            }

            this.viewMenu = true;

            Vue.nextTick(function() {
                this.$refs.right.focus();

                this.setMenu(e.y, e.x)
            }.bind(this));
        },

        triggerNodeAction(action) {
            switch(action) {
                case 'Delete':
                    this.removeNode(this.currentMenuNode)
                    break
                case 'Add file':
                    this.addFile(this.currentMenuNode)
                    break
                case 'Add folder':
                    this.addFolder(this.currentMenuNode)
                    break
                case 'Rename':
                    this.renameNode(this.currentMenuNode)
                    break
            }

            this.closeMenu()
        },

        renameNode(node) {
            if (node.editNodeDisabled) {
                return
            }

            this.nodeEditable = node.id
            Vue.nextTick(function() {
                this.$refs.renameInput.focus();
            }.bind(this));
        },

        removeNode(node) {
            if (node.delNodeDisabled) {
                return
            }

            this.$bvModal.msgBoxConfirm("Are you sure?",{
                headerBgVariant: 'dark',
                footerBgVariant: 'dark',
                bodyBgVariant: 'dark'
            }).then(resp => {
                if (resp) node.remove()
            })  
        },
        
        addFile(node) {
            node.addChildren(new TreeNode(
                {
                    name: 'new file',
                    isLeaf: true,
                    dragDisabled: false,
                    addTreeNodeDisabled: true,
                    addLeafNodeDisabled: true,
                    delNodeDisabled: false,
                    editNodeDisabled: false,
                    children: null,
                    editorOptions: {
                        mode: 'text/plain'
                    }
                }
            ))
        },

        addFolder(node) {
            node.addChildren(new TreeNode(
                {
                    name: 'new folder',
                    isLeaf: false,
                    dragDisabled: false,
                    addTreeNodeDisabled: false,
                    addLeafNodeDisabled: false,
                    delNodeDisabled: false,
                    editNodeDisabled: false,
                    children: []
                }
            ))
        },

        nodeActions() {
            let actions = []
            let node = this.currentMenuNode;
            if (!node.isLeaf) {
                actions.push
                if (!node.addLeafNodeDisabled) {
                    actions.push("Add file")
                }

                if (!node.addTreeNodeDisabled) {
                    actions.push("Add folder")
                }
            }

            if (!node.delNodeDisabled) {
                actions.push("Delete")
            }

            if (!node.editNodeDisabled) {
                actions.push("Rename")
            }

            return actions;
        },

        nodeNameChange() {
            this.currentMenuNode.changeName(this.currentMenuNode.name)
            this.nodeEditable = null
            this.onChangeName({newName: this.currentMenuNode.name, node: this.currentMenuNode})
        },

        onSidebarResize(x, y, width) {
            this.$refs.editorPanel.style.marginLeft = width + "px"
        }
    },

    async mounted() {
        try {
            let { data } = await this.$http.get("/v3/system/component/settings/" + this.$route.params.id + "/" + this.$route.query.v)

            this.component = data

            this.nodes = [
                {
                    name: this.component.general.name,
                    id: 1,
                    pid: 0,
                    root: true,
                    dragDisabled: true,
                    editNodeDisabled: true,
                    delNodeDisabled: true,
                    addTreeNodeDisabled: true,
                    addLeafNodeDisabled: true,
                    children: [
                        {
                            name: 'templates',
                            id: 2,
                            pid: 1,
                            dragDisabled: true,
                            addTreeNodeDisabled: false,
                            addLeafNodeDisabled: false,
                            delNodeDisabled: true,
                            editNodeDisabled: true,
                            children: this.component.settings.templates || []

                        }
                    ]
                }
            ]

            if (this.component.settings.templates_dist) {
                this.SDKVersion = this.component.settings.templates_dist.sdk_version
                this.SDKEngine = this.component.settings.templates_dist.sdk_engine
            } 

            this.ready = true

       }  catch(err) {
            this.$debugLog(err)
            this.$bvModal.msgBoxOk("Failed to fetch component settings.")
        }

        document.onkeyup = function(e) {
            if (e.ctrlKey && e.code == 'KeyS') {
                this.save()
            }
        }.bind(this);
    }
}
</script>